/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type AfterDateValueConfigKind = (typeof AfterDateValueConfigKind)[keyof typeof AfterDateValueConfigKind];

export const AfterDateValueConfigKind = {
  after: 'after',
} as const;
